import { Component } from '@angular/core';
import { OeAppService } from '../../shared/oe-app.service';
import { WindowService } from '../../shared/window.service';
import { Language } from '../../shared/types/language';

@Component({
  selector: 'lp2-referral-page-link',
  templateUrl: './referral-page-link.component.html',
  styleUrls: ['./referral-page-link.component.scss'],
})
export class ReferralPageLinkComponent {
  isDisplayed = false;
  displayForLanguages = [Language.ENGLISH, Language.SPANISH, Language.PORTUGUESE, Language.TURKISH];

  constructor(oeAppService: OeAppService, private windowService: WindowService) {
    const person = oeAppService.getData('person');
    this.isDisplayed = person.id && this.displayForLanguages.indexOf(person.preferredLang) > -1;
  }

  redirectToReferral() {
    this.windowService.redirectToUrl('/referrals.html');
  }
}



// WEBPACK FOOTER //
// ./ts/app/header/referral-page-link/referral-page-link.component.ts